import { ExportBuilder } from './exportBuilder.ts';
import '../../../components/modals/as-modal-export-progress.ts';

ExportBuilder.registerModal({ tagName: 'as-modal-export-progress', id: 'export-progress', disableBgClose: true });
